import { COLORS } from "../constants";

export const LogoScreen = () => {
  return (
    <div
      className="d-flex vh-100 w-100 justify-content-center align-items-center"
      style={{ backgroundColor: COLORS.BRAND }}
    >
      <img
        src={require("../assets/full-new-logo.png")}
        alt="logo"
        height="150px"
      />
    </div>
  );
};
